import { storeSelector, usePolicyContext } from '@Policy/store';
import { raiActionDataSelector } from '@Policy/store/filters/riskAI';
import { PolicyModeEnum } from '@Policy/utils/constants';
import Actions from '../../../Components/Actions';
import isEqual from 'lodash/isEqual';

function SpamSection() {
  const contextStore = usePolicyContext();
  const contextSelector = storeSelector(contextStore);
  const { spamActionData, policyMode } = contextSelector((s) => {
    const actionData = raiActionDataSelector(s);
    return {
      spamActionData: actionData.spamActionData,
      policyMode: s.template.policyMode,
    };
  }, isEqual);

  return (
    <Actions
      actionData={spamActionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
}

export default SpamSection;
